import ComicCard from '@/components/base/ComicCard';
import { latestComicIds, getComicById } from '@/mocks/comics';
import { categories } from '@/mocks/categories';

export default function LatestUpdates() {
  const latestComics = latestComicIds.map((id) => getComicById(id)).filter(Boolean);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <span className="w-1 h-6 rounded-full bg-primary-500"></span>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900">
              最近更新
            </h2>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => {
            if (!comic) return null;
            const cat = categories.find((c) => c.id === comic.category);
            return (
              <ComicCard
                key={comic.id}
                id={comic.id}
                slug={comic.slug}
                title={comic.title}
                author={comic.author}
                category={comic.category}
                status={comic.status}
                rating={comic.rating}
                views={comic.views}
                chapters={comic.chapters}
                coverImage={comic.coverImage}
                categoryName={cat?.name}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}